import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermission } from '../../Context Api/PermissionContext.js';
import ProtectedRoute from './ProtectedRoute';

const PermissionProtectedRoute = ({ requiredPermission }) => {
  const { hasPermission, loading } = usePermission();


  if (loading) {
    return <div>Loading...</div>; // Or a more sophisticated loading component
  }

  if (!hasPermission(requiredPermission)) {
    return <Navigate to="/modules" replace />; // Redirect to dashboard if no permission
  }

  return <ProtectedRoute />;
};

export default PermissionProtectedRoute;